import { history } from '@umijs/max';
import { Button, Result } from 'antd';
import React from 'react';
const App: React.FC = () => (
  <Result
    status="403"
    title="您没有当前页面权限"
    subTitle="抱歉，您无权限访问当前页面，请尝试其它的链接地址，或回到首页. 若您认为这是一个系统问题，请联系系统管理员并描述您遇到的问题详情"
    extra={
      <Button type="primary" onClick={() => history.push('/')}>
        返回首页
      </Button>
    }
  />
);

export default App;
